/** Compare catalog fingerprints from GET /catalog/revision. */

export function isCatalogStale(
  pinned: string | null,
  live: string | null,
  dismissed: string | null,
): boolean {
  if (!live || !pinned) return false
  if (live === pinned) return false
  if (dismissed === live) return false
  return true
}

/** Backoff after an SSE drop: 1s, 2s, 4s … capped at 15s. */
export function catalogReconnectDelay(attempt: number): number {
  const exp = Math.max(0, attempt)
  return Math.min(15_000, 1000 * 2 ** exp)
}
